import { render, staticRenderFns } from "./LEDStrip65GameBoy.vue?vue&type=template&id=4a170c3c&scoped=true&"
import script from "./LEDStrip65GameBoy.vue?vue&type=script&lang=js&"
export * from "./LEDStrip65GameBoy.vue?vue&type=script&lang=js&"
import style0 from "./LEDStrip65GameBoy.vue?vue&type=style&index=0&id=4a170c3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a170c3c",
  null
  
)

export default component.exports